import { PropsWithChildren, useEffect } from 'react'
import { RootState, useAppSelector } from '../utils/agent.store'
import { useNavigate, useParams } from 'react-router-dom'

const NavigateToPage: React.FC<{ url: string }> = ({ url }) => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate(url)
  }, [url])
  return <></>
}

export const CurrentUserProtectedRoute: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { userId } = useParams()
  const currentUserId = useAppSelector(
    (state: RootState) => state?.authUser?.user?.id
  )

  if (userId && currentUserId?.toString() === userId) {
    return <NavigateToPage url="/" />
  } else {
    return children
  }
}
